<div class='modal-header modal-header--full'>
  <h4 class='modal-title'>
    <span *ngIf="!penTestDialog.penTest">{{'TITLE.PEN_TEST_NEW' | translate}}</span>
    <span *ngIf="penTestDialog.penTest">{{'TITLE.PEN_TEST' | translate}}: {{appPenTest?.appName}}</span>
  </h4>
</div>

<div class='modal-body modal-body--full bg-white'>

  <form [formGroup]="formGroup">
    <div class="header-container">
      <div class="rid-container" *ngIf="!!penTestDialog.penTest">
        <pt-rid-viewer
          [impactMetricsLabels]="appPenTest?.impactMetricsLabels"
          [withTransaction]="true"
          [impactMetrics]="appPenTest?.impactMetrics">
        </pt-rid-viewer>
      </div>
      <div class="pen-test-form-container">
        <div class="pen-test-input-container pen-test-input-select">
          <label class="form-label position-relative">
            {{'PAGE.PEN_TEST.DIALOG.APPLICATION' | translate}}
            <div class="required">*</div>
          </label>
          <ng-select [items]="applications"
                     [searchable]='true'
                     [className]="'pt-ng-select'"
                     [ngClass]="{'invalid-select': formGroup.controls.applicationId.invalid}"
                     [bindLabel]="'name'"
                     [bindValue]="'id'"
                     class='mb-3'
                     [multiple]="false"
                     [closeOnSelect]="true"
                     formControlName="applicationId">
          </ng-select>
        </div>

        <div class="pen-test-input-container me-0">
          <label for="ptAuthor"
                 class="form-label position-relative">
            {{'PAGE.PEN_TEST.DIALOG.AUTHOR' | translate}}
            <div class="required">*</div>
          </label>
          <input type="text"
                 [ngClass]="{'invalid-input': formGroup.controls.author.invalid}"
                 class="form-control form-control-sm"
                 id="ptAuthor"
                 formControlName="author">
        </div>

        <div class="pen-test-input-container pen-test-input-time-picker">
          <pt-input-time-date-picker
            [controlName]="'startedAt'"
            [isRequired]="true"
            [label]="'PAGE.PEN_TEST.DIALOG.START' | translate"
            [lang]='currentLanguage$ | async'
            formControlName='startedAt'>
          </pt-input-time-date-picker>
          <div class="error-time-picker" *ngIf="errorStartDateMessage">{{errorStartDateMessage | async}}</div>
        </div>

        <div class="pen-test-input-container pen-test-input-time-picker me-0">
          <pt-input-time-date-picker
            [controlName]="'completedAt'"
            [isRequired]="true"
            formControlName='completedAt'
            [label]="'PAGE.PEN_TEST.DIALOG.END' | translate"
            [lang]='currentLanguage$ | async'>
          </pt-input-time-date-picker>
          <div class="error-time-picker" *ngIf="errorCompletedDateMessage">{{errorCompletedDateMessage | async}}</div>
        </div>


      </div>
      <div class="pen-test-form-note-container" [ngClass]="{'pen-test-form-note-container-new': !appPenTest}">
        <div class="pen-test-textarea-container">
          <div class="d-flex flex-column w-100" style="margin-right: 0;">
            <label
              class="form-label position-relative">
              {{'PAGE.PEN_TEST.DIALOG.NOTE' | translate}}</label>
            <textarea
              class="pen-test-note form-control form-control-sm"
              style="height: 95px;  min-height: 95px;"
              formControlName="note">
              </textarea>
          </div>
        </div>
      </div>
    </div>


    <div class="pen-test-table" [ngClass]="{'new-pen-test-table': !appPenTest}">
      <div class="pen-test-table-action">
        <div>{{'LABELS.VULNERABILITY' | translate}}</div>
        <div class="buttons">
          <button type='button' class='btn btn-success btn-sm ms-2'
                  [disabled]="loading"
                  (click)='add();'>
            <pt-icon [key]='IconAdd'></pt-icon>
            {{'BUTTON.ADD' | translate}}
          </button>
          <button type='button' class='btn btn-outline-primary btn-sm ms-2'
                  [disabled]="loading"
                  (click)='reload()'>
            <pt-icon [key]='IconReload'></pt-icon>
          </button>
        </div>
      </div>

      <div class='w-100 h-100'>
        <div *ngIf="!gridOption" class="loading-container">
          <div class="spinner-border spinner-border-sm me-2 text-muted" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          {{'MESSAGE.LOADING' | translate}}
        </div>

        <ag-grid-angular
          *ngIf="gridOption"
          class='ag-theme-balham w-100 h-100'
          [headerHeight]="30"
          [gridOptions]='gridOption'
          [singleClickEdit]="true"
          [stopEditingWhenCellsLoseFocus]="true"
          (cellValueChanged)="cellValueChanged($event)"
          (gridReady)="onGridReady($event)"
        ></ag-grid-angular>

        <ng-template #actionCol let-node>
          <pt-icon [key]='IconClose' (click)="removeRow(node)"></pt-icon>
        </ng-template>
      </div>

    </div>
  </form>

</div>

<div class='modal-footer modal-footer--full bg-white'>
  <button *ngIf="penTestDialog.penTest"
          type='button' class='btn btn-primary btn-sm ms-1 me-0'
          [disabled]="!enableChange || loading || formGroup.invalid || errorCompletedDateMessage || errorStartDateMessage"
          (click)='upsert(false);'>
    {{ 'BUTTON.SAVE' | translate }}
  </button>
  <button type='button' class='btn btn-primary btn-sm ms-1 me-0'
          [disabled]="!enableChange || loading || formGroup.invalid || errorCompletedDateMessage || errorStartDateMessage"
          (click)='upsert(true);'>
    <span *ngIf="penTestDialog.penTest">{{ 'BUTTON.SAVE_AND_CLOSE' | translate }}</span>
    <span *ngIf="!penTestDialog.penTest">{{ 'BUTTON.CREATE' | translate }}</span>
  </button>
  <button ngbAutofocus type='button'
          class='btn btn-outline-secondary btn-sm ms-1 me-0'
          (click)='close(false)'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>
